<template>
    <div>
        <b-button-group size="sm" class="w-100">
            <b-button
                variant="table"
                v-if="checkActionAllow('show')"
                @click="showItem(row.index)"
                title="Просмотр"
            >
                <i class="fas fa-eye"></i>
            </b-button>
            <b-button
                variant="table"
                v-if="checkActionAllow('edit')"
                @click="createOrEditItemModal(row.index)"
                title="Редактировать"
            >
                <i class="fas fa-pencil-alt"></i>
            </b-button>
            <b-button
                variant="table"
                v-if="checkActionAllow('publish') && row.item.status === 'draft'"
                @click="publishNews(row.index)"
                title="Опубликовать"
            >
                <i class="fas fa-globe text-success"></i>
            </b-button>
            <b-button
                variant="table"
                v-if="checkActionAllow('schedule') && row.item.status === 'draft'"
                @click="scheduleNews(row.index)"
                title="Запланировать"
            >
                <i class="fas fa-clock text-warning"></i>
            </b-button>
            <b-button
                variant="table"
                v-if="checkActionAllow('archive') && row.item.status === 'published'"
                @click="archiveNews(row.index)"
                title="В архив"
            >
                <i class="fas fa-archive text-info"></i>
            </b-button>
            <b-button
                variant="table"
                v-if="checkActionAllow('delete')"
                @click="deleteItem(row.index)"
                title="Удалить"
            >
                <i class="fas fa-trash text-danger"></i>
            </b-button>
        </b-button-group>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import {
        checkActionAllow
    } from '@/mixins'

    export default {
        props: {
            row: {type: Object, required: true},                                                // Row of table
            actionAllows: {type: Array, required: false, default: function () { return [] }},   // Array of rules for action allows
        },
        mixins: [
            checkActionAllow
        ],
        computed: {
            ...mapGetters('auth', ['currentUser'])
        },
        methods: {
            showItem(index) {
                this.$emit('universalEmit', 'show', index)
            },
            createOrEditItemModal(index) {
                this.$emit('universalEmit', 'edit', index)
            },
            publishNews(index) {
                this.$emit('universalEmit', 'publish', index)
            },
            scheduleNews(index) {
                this.$emit('universalEmit', 'schedule', index)
            },
            archiveNews(index) {
                this.$emit('universalEmit', 'archive', index)
            },
            deleteItem(index) {
                this.$emit('universalEmit', 'delete', index)
            }
        }
    }
</script>
